import React from 'react'
import { FormGroup } from 'shared'
import { GoogleWebfontCheck } from './google_webfont_check'
import { SuggestedFonts } from './suggested_fonts'
import { WidgetField } from '../../live_widgets'
import { WidgetFieldFontProps } from '../types'
import { WidgetParamsKey } from 'fe_manage/live_widgets/types'

export const FontFamily = <K extends WidgetParamsKey>({ widget, formikProps }: WidgetFieldFontProps<K>) => {
  if (!('fontFamily' in formikProps.values)) return null

  const selectFont = (font: string) => {
    void formikProps.setFieldValue('fontFamily', font)
  }

  return (
    <>
      <label htmlFor="fontFamily">
        {i18n.t(`fundraising_events.manage.live_widgets.configurator.font_family_label`)}
      </label>
      <div className="relative">
        <WidgetField widget={widget} name="fontFamily" labelClass="hidden" groupClass="mb-2" component={FormGroup} />
        <GoogleWebfontCheck font={formikProps.values.fontFamily} selectFont={selectFont} />
      </div>
      <SuggestedFonts selectFont={selectFont} />
    </>
  )
}
